/**
 * Where a finished setup wizard sends the owner: the ADMIN app, whichever
 * staff app they happened to start from — setting a new business up is admin
 * work, and the till/KDS/calendar are opened from there once it is.
 *
 * An app that knows the admin URL passes it (the cashier's VITE_ADMIN_URL).
 * Otherwise it follows the deployment's naming: the test stack is
 * `test-<app>.matix.one` and prod `<app>.matix.one`, so the admin is
 * `test-posadmin.matix.one` / `posadmin.matix.one`; local dev runs it on :5175.
 */
export function resolveAdminUrl(configured?: string | null): string {
  if (configured && /^https?:\/\//.test(configured)) return configured.replace(/\/+$/, '');
  if (typeof window === 'undefined') return 'https://posadmin.matix.one';
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return `${window.location.protocol}//${host}:5175`;
  return host.startsWith('test-') ? 'https://test-posadmin.matix.one' : 'https://posadmin.matix.one';
}

/** Open the admin app's sign-in with the workspace already filled in. */
export function goToAdminSignIn(tenantSlug: string, configured?: string | null): void {
  window.location.assign(`${resolveAdminUrl(configured)}/?tenant=${encodeURIComponent(tenantSlug)}`);
}
